import * as Yup from "yup";
import { setIn } from "formik";
import { CUSTOMER_ADDRESS_TYPE_OPTIONS } from "../../../../utils/customerAddressTypes";

export const CUSTOMER_ADDRESS_COUNTRY_OPTIONS = Object.freeze([
  "Canada",
  "United States",
  "Mexico",
]);

const CUSTOMER_ADDRESS_COUNTRY_ALIASES = Object.freeze({
  canada: "Canada",
  ca: "Canada",
  "united states": "United States",
  "united states of america": "United States",
  usa: "United States",
  us: "United States",
  mexico: "Mexico",
  mx: "Mexico",
});

const trimmedRequiredString = (message) =>
  Yup.string().trim().required(message);

export function normalizeCustomerAddressCountry(value) {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return "";
  return CUSTOMER_ADDRESS_COUNTRY_ALIASES[normalized] || String(value || "").trim();
}

export function getCustomerAddressRegionLabel(country) {
  return normalizeCustomerAddressCountry(country) === "Canada"
    ? "Province"
    : "State";
}

export const customerAddressValidationSchema = Yup.object({
  addresses: Yup.array().of(
    Yup.object({
      addressName: trimmedRequiredString("Address Name is required"),
      addressType: Yup.string().oneOf(
        CUSTOMER_ADDRESS_TYPE_OPTIONS.map(option => option.value),
        "Address Type must be Billing, Shipping, or Both",
      ).default("both"),
      street: trimmedRequiredString("Street is required"),
      city: trimmedRequiredString("City is required"),
      state: trimmedRequiredString("State is required"),
      postal: trimmedRequiredString("Postal Code is required"),
      country: trimmedRequiredString("Country is required").test(
        "customer-address-country-supported",
        "Country must be Canada, United States, or Mexico",
        (value) =>
          CUSTOMER_ADDRESS_COUNTRY_OPTIONS.includes(
            normalizeCustomerAddressCountry(value),
          ),
      ),
    }),
  ),
});

function toFormikPath(path = "") {
  return String(path).replace(/\.([0-9]+)(?=\.|$)/g, "[$1]");
}

export function mapAddressErrorsToFormik(errors = {}) {
  return Object.entries(errors).reduce((accumulator, [path, message]) => {
    if (!path) return accumulator;
    return setIn(accumulator, toFormikPath(path), message);
  }, {});
}

export function mapAddressTouchedToFormik(errors = {}) {
  return Object.keys(errors).reduce((accumulator, path) => {
    if (!path) return accumulator;
    return setIn(accumulator, toFormikPath(path), true);
  }, {});
}
